import * as types from './constants';

export const openPricingModal = () => (
  { type: types.OPEN_PRICING_MODAL }
);

export const closePricingModal = () => (
  { type: types.CLOSE_PRICING_MODAL }
);
